import { TextField } from '@material-ui/core'
import { numberWithCommas } from '@openhouse-technologies/utils'
import React from 'react'

import PaymentBreakup from './PaymentBreakup'

import * as Styles from '../styles'

const formatRupeesFromPaise = (paise) =>
  paise || paise === 0 ? `₹${numberWithCommas(Math.round(paise / 100))}` : '—'

/**
 * "Book with e-Mandate" checkout.
 *
 * The one thing this screen has to make unmissable is that confirming here does NOT
 * book anything today: the parent is notified now and debited after 24 hours, and the
 * child is enrolled only once that debit succeeds. Everything else is context for the
 * amount being authorised.
 */
const BookWithEmandate = ({
  activeOption,
  excelPaymentSummary,
  upcomingExcelPaymentSummary,
  reasonForUsingAlfred,
  setReasonForUsingAlfredHandler,
  reasonError,
  showReasonField
}) => {
  const handleReasonChange = (event) => {
    setReasonForUsingAlfredHandler(event.target.value)
  }

  const payableNow = excelPaymentSummary?.find(
    (item) => item.type === 'Total' && item.label === 'Payable Now'
  )
  const monthlyPayable = upcomingExcelPaymentSummary?.find(
    (item) => item.label === 'monthly payable'
  )

  return (
    <>
      <Styles.ContentContainer>
        <Styles.CartValue>
          <span>payable now</span>
          <Styles.CoinsContainer>
            <Styles.TotalAmount>
              ₹{numberWithCommas(payableNow?.value ?? 0)}
            </Styles.TotalAmount>
          </Styles.CoinsContainer>
        </Styles.CartValue>

        {/* How the debited figure is arrived at — programs, discount, GST, coins burnt.
            Without it the screen asserts an amount and the centre has nothing to answer
            "why this number?" with when the parent asks. */}
        <PaymentBreakup
          summary={excelPaymentSummary}
          heading="payment breakup"
        />

        <Styles.Subheading>auto-debit summary</Styles.Subheading>
        <Styles.PaymentSummary>
          <Styles.SummaryItem>
            <span>e-mandate limit</span>
            <span>{formatRupeesFromPaise(activeOption?.max_amount)}</span>
          </Styles.SummaryItem>
          <Styles.SummaryItem>
            <span>amount to be debited</span>
            <span>₹{numberWithCommas(payableNow?.value ?? 0)}</span>
          </Styles.SummaryItem>
          {monthlyPayable ? (
            <Styles.SummaryItem>
              <span>monthly auto-pay from next month</span>
              <span>₹{numberWithCommas(monthlyPayable?.value)}</span>
            </Styles.SummaryItem>
          ) : null}
        </Styles.PaymentSummary>

        <Styles.Notice>
          <strong>The class is booked once the money is collected.</strong> The
          auto-debit starts as soon as you confirm. The parent&apos;s bank sends
          them the mandate notification, and UPI auto-pay typically settles in
          24&ndash;36 hours (cards are usually instant). The order stays pending
          in Orders until then; if the debit fails, the booking is cancelled and
          the centre gets a ticket.
        </Styles.Notice>
      </Styles.ContentContainer>

      {showReasonField ? (
        <TextField
          name="reason_for_using_alfred"
          label="Reason for using Alfred instead of the App"
          variant="outlined"
          fullWidth
          required
          value={reasonForUsingAlfred}
          onChange={handleReasonChange}
          error={!!reasonError}
          helperText={reasonError}
          style={{ paddingBottom: '10px' }}
        />
      ) : null}
    </>
  )
}

export default BookWithEmandate
